import { gql } from 'apollo-boost';

import { TipoDeEmprestimoTipoCalculo } from 'types/graphql';

export interface EntityLoanTypeNode {
  id: string;
  pk: number;
  nome: string;
  taxaJuros: number;
  tcc: number;
  parcelasMinimas: number;
  parcelasMaximas: number;
  valorMinimo: number;
  valorMaximo: number;
  tipoCalculo?: TipoDeEmprestimoTipoCalculo;
}

export interface EntityWithLoanTypesData {
  entidade: {
    id: string;
    pk: number;
    tiposEmprestimo: {
      edges: Array<{ node: EntityLoanTypeNode }>;
    };
  };
}

export const getEntityWithLoanTypes = gql`
  query getEntityWithLoanTypes($id: Int) {
    entidade(id: $id) {
      id
      tiposEmprestimo {
        edges {
          node {
            id
            pk
            nome
            taxaJuros
            tcc
            parcelasMinimas
            parcelasMaximas
            valorMinimo
            valorMaximo
            tipoCalculo
          }
        }
      }
    }
  }
`;
